import React, { useEffect } from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";

import { EventSwitcher } from ".";
import { EventPageTitle } from "./EventPageTitle";

export const EventPageSubheader = observer(function EventPageSubheader() {
	const rootStore = useRootAppStore();

	useEffect(() => {
		rootStore.eventSwitcherViewStore.onInitialize();
		return () => rootStore.eventSwitcherViewStore.onDispose();
	}, []);

	return (
		<nav className="header header--sub">
			<EventPageTitle />
			<EventSwitcher />
		</nav>
	);
});
